(() => {
  const buttons = Array.from(document.querySelectorAll('[data-scroll-to-top]'));
  if (!buttons.length) return;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setVisibility = (button, visible) => {
    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    button.tabIndex = visible ? 0 : -1;
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      buttons.forEach((button) => {
        const threshold = parseInt(button.dataset.showAfter || '300', 10);
        setVisibility(button, scrollY > threshold);
      });
      ticking = false;
    });
  };

  const onClick = (event) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  };

  buttons.forEach((button) => {
    button.addEventListener('click', onClick);
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.addEventListener('shopify:section:load', (event) => {
    const targetButtons = Array.from(event.target.querySelectorAll('[data-scroll-to-top]'));
    targetButtons.forEach((button) => {
      button.addEventListener('click', onClick);
    });
    onScroll();
  });
})();
